import { smartAxios } from "../axios/Axios";
import { analyticsEndpoints } from "./analyticsEndpoints";

export const getRevenue = () => {
  return smartAxios.get(analyticsEndpoints.getRevenue);
};
export const getUsers = () => {
  return smartAxios.get(analyticsEndpoints.getUsers);
};
export const getCustomers = () => {
  return smartAxios.get(analyticsEndpoints.getCustomers);
};
export const getConnections = () => {
  return smartAxios.get(analyticsEndpoints.getConnections);
};
export const getIntegrations = () => {
  return smartAxios.get(analyticsEndpoints.getIntegrations);
};
export const getFirstRegistration = () => {
  return smartAxios.get(analyticsEndpoints.getFirstRegistration);
};
export const getNiches = () => {
  return smartAxios.get(analyticsEndpoints.getNiches);
};
export const getSoloVsSalon = () => {
  return smartAxios.get(analyticsEndpoints.getSoloVsSalon);
};
export const getCouponAffiliateStats = () => {
  return smartAxios.get(analyticsEndpoints.getCouponAffiliateStats);
};
